import React, { useMemo, useState } from "react";
import { normalizeAdminRichText } from "../../utils/richText";

export default function FaqPanel({ data }) {
  const preguntas = useMemo(
    () => (Array.isArray(data?.preguntas) ? data.preguntas : []),
    [data],
  );

  const [query, setQuery] = useState("");
  const [openId, setOpenId] = useState(preguntas[0]?.id ?? null);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return preguntas;
    return preguntas.filter(
      (item) =>
        String(item?.pregunta ?? "")
          .toLowerCase()
          .includes(q) ||
        String(item?.respuesta ?? "")
          .toLowerCase()
          .includes(q),
    );
  }, [preguntas, query]);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <div className="scm-faq">
      <div className="scm-search scm-search--full">
        <i className="bi bi-search scm-search__icon" aria-hidden />
        <input
          type="search"
          className="scm-search__input"
          placeholder="Buscar pregunta…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label="Buscar en preguntas frecuentes"
        />
      </div>

      {filtered.length === 0 ? (
        <p className="scm-empty">No se encontraron preguntas.</p>
      ) : (
        <div className="scm-faq__list">
          {filtered.map((item) => {
            const expanded = openId === item.id;
            return (
              <div
                key={item.id}
                className={`scm-faq__item${expanded ? " is-open" : ""}`}
              >
                <button
                  type="button"
                  className="scm-faq__question"
                  aria-expanded={expanded}
                  onClick={() => toggle(item.id)}
                >
                  <span>{item.pregunta}</span>
                  <i
                    className={`bi bi-chevron-${expanded ? "up" : "down"}`}
                    aria-hidden
                  />
                </button>
                {expanded ? (
                  <div
                    className="scm-faq__answer rich-text"
                    dangerouslySetInnerHTML={{
                      __html: normalizeAdminRichText(item.respuesta),
                    }}
                  />
                ) : null}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
